<template>
  <section class="topbar">
    <div class="icon" @click="menuStore.toggleMenu">
      <div class="hamburger-menu">
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
        <span class="hamburger-line"></span>
      </div>
    </div>
    <h1 v-if="title" class="page-title">{{title}}</h1>
    <nav class="support-navigation">
      <div class="icon">
        <p-icon icon-name="video"
                   size="large"
                   :boxed="false"
                   color="blue"
                   background="blue" />
      </div>
      <div class="icon">
        <p-icon icon-name="service"
                   size="large"
                   :boxed="false"
                   color="blue"
                   background="blue" />
      </div>
    </nav>
  </section>
</template>
<script lang="ts" setup>
import { useMenuStore } from '@pidz/stores';

const menuStore = useMenuStore();

defineProps<{ title: string | undefined }>();
</script>
<style lang="scss" scoped>

.topbar {
    background-color: white;
    height: 64px;
    padding: 0 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    #app & > .icon {
      @media only screen and (min-width: map.get($screen-sizes, 'extra-large')) {
        display: none;
      }
    }

  .page-title {
    padding: 0;
    margin: 0;
    color: var(--pidz-blue);
    line-height: 1;
    font-size: 20px;
    font-weight: 700;
    font-style: normal;
  }

  .support-navigation {
    display: flex;
    color: var(--pidz-blue);

    .icon {
      height: 30px;

      &:not(:first-of-type) {
        margin-left: 16px;
      }
    }
  }
}
</style>
